import React, { FC, PropsWithChildren } from 'react'
import { TagProps, LabelProps } from '@sport1/types/web'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { PixelType, ResponsiveType, SystemSpacingsProps } from '@sport1/news-styleguide/Types'
import clsx from 'clsx'
import TeaserCardHeadline from './Headline'

interface CardProps extends SystemSpacingsProps {
    backgroundColor?: 'pearl' | 'onyx'
    hint?: string
    lazy?: boolean
    disableContentSpaceX?: boolean
    minHeight?: ResponsiveType<number | PixelType>
    tag?: TagProps | LabelProps
    testID?: string
    title?: string
    titleHref?: string
    onPress?: () => void
    /**use this flag on HorizontalTeaserCards, to show hint text when no title exists */
    hasPadding?: boolean
    showHintText?: boolean
    className?: string
}

const Card: FC<CardProps & PropsWithChildren> = ({
    children,
    backgroundColor,
    hint,
    lazy,
    disableContentSpaceX,
    marginBottom,
    minHeight,
    tag,
    testID,
    title,
    titleHref,
    showHintText,
    hasPadding,
    className,
    onPress,
}) => {
    return (
        <NonFlexingContainer marginBottom={marginBottom} testID={testID}>
            <NonFlexingContainer
                marginBottom={hasPadding ? 'spacing-11' : undefined}
                paddingX={
                    hasPadding ? ['spacing-6', 'spacing-6', 'spacing-9', 'spacing-11'] : undefined
                }
                paddingTop={
                    hasPadding
                        ? ['spacing-none', 'spacing-none', 'spacing-none', 'spacing-11']
                        : undefined
                }
                paddingBottom={
                    hasPadding
                        ? ['spacing-none', 'spacing-none', 'spacing-none', 'spacing-11']
                        : undefined
                }
                backgroundColor={backgroundColor}
                minHeight={minHeight}
                testID={`${testID}-wrapper`}
                className={clsx(className, { 'px-3 sm:px-3 md:px-0': !disableContentSpaceX })}
            >
                {(title || showHintText) && (
                    <TeaserCardHeadline
                        title={title || ''}
                        titleHref={titleHref}
                        onPress={onPress}
                        hint={hint}
                        tag={tag}
                        lazy={lazy}
                        showHintText={showHintText}
                        testID={`${testID}-teaser-card-headline`}
                    />
                )}
                {children}
            </NonFlexingContainer>
        </NonFlexingContainer>
    )
}

export default Card
